module.exports = __webpack_public_path__ + "static/media/the_orphans.cb4d411f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/originals/the_orphans.jpg
// module id = 124
// module chunks = 0